const CLASS_NAME = 'using-mouse';

document.addEventListener('mousedown', function () {
    document.body.classList.add(CLASS_NAME);
});

document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') document.body.classList.remove(CLASS_NAME);
});
